/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.Legend = function( data, config) {
    var LegendItem = expocadfx.LegendItem;
    var txt = expocadfx.txt;
    
	var red;
	var grn;
	var bl;
	var bg;
    var len = 0;
    var i = 0;
    var item = null;
    var ul = document.createElement( "ul");
	ul.setAttribute( "class", "legend");
	
	
	if( config.legendFontSize !== "") {
		ul.style.fontSize = config.legendFontSize + "px";
	}
	
	if( config.clrLegendBackground !== "") {
		red = parseInt( config.clrLegendBackground.slice( 1, 3), 16)
		grn = parseInt( config.clrLegendBackground.slice( 3, 5), 16)
		bl = parseInt( config.clrLegendBackground.slice( 5, 7), 16)
		bg = "rgba(" + red + ", " + grn + ", " + bl + ", " + config.LegendBackgroundAlpha + ")";
		
		ul.style.backgroundColor = bg;
	}
	
	if( config.LegendTextColor !== "") {
		ul.style.color = config.LegendTextColor;
	}
    
    if( data.numAvailableBooths > 0 && config.legendAvailable) {
        item = new LegendItem( txt.LEGEND_AVAILABLE, config.clrAvailable);
        ul.appendChild(item);
    }
    if( data.numOnHoldBooths > 0 && config.legendHold) {
        item = new LegendItem( txt.LEGEND_HOLD, config.clrHold);
        ul.appendChild(item);
    }
    
	if( config.legendRent) {
		item = new LegendItem( txt.LEGEND_RENTED, config.clrRent);
		ul.appendChild(item);
	}
    
    if( config.fillRentedWithExpocadColor || config.fillAvailableWithExpocadColor || config.fillOnHoldWithExpocadColor) {
        len = config.arBoothClasses.length;
        if( len > 0) {
                //  for each booth class
            for( i = 0; i < len; i++) {
                item = new LegendItem( config.arBoothClasses[i].name, config.arBoothClasses[i].color);
                ul.appendChild(item);
            }
        }
    }
    return ul;
};